module.exports = __webpack_public_path__ + "static/media/lock-red.c51ced81.svg";